import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ClientOrderService } from '../clientorderreport/clientorderreport.service';
import * as moment from 'moment';
import { UserService } from '../services/user.service';
import { TableUtil } from './tableUtil';
import { EditAdminTradeMasterDialog } from "./edit-admin-trade-master/edit-admin-trade-master.component";

@Component({
    selector: 'app-admintrademaster',
    templateUrl: './admintrademaster.component.html',
    styleUrls: ['./admintrademaster.component.css']
})
export class AdminTradeMasterReportComponent implements OnInit {
    displayedColumns = [
        'Action',
        'Pair',
        'SourceTradeTS',
        'SourceTradeDate',
        'SourceOrderSource',
        'SourceSide',
        'SourceClient',
        'SourceUserEmail',
        'SourceOrderId',
        'SourceClientOrderId',
        'SourceTradeId',
        'SourceTradeQuantity',
        'SourceTradePrice',
        'SourceTradeAmount',
        'SourceFee',
        'SourceFeeCurrency',
        'createdAt',
        'TargetTradeTS',
        'TargetExchange',
        'TargetSide',
        'TargetOrderId',
        'TargetTradeId',
        'TargetClientOrderId',
        'TargetOrderSource',
        'TargetOrderStatus',
        'TargetTradePrice',
        'TargetTradeQuantity',
        'TargetTradeAmount',
        'TargetFee',
        'TargetFeeCurrency',
        'PNL',
        'CommentText',
        'IsActive'
    ];
    pageSize = 25;
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<AdminOrderData>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private clientOrderSer: ClientOrderService,
        public dialog: MatDialog,
        private userService: UserService) {
    }

    ngOnInit() {
        this.adminOrderReport();
        const fDate = Date.UTC(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate());
        const tDate = Date.UTC(this.selectedDate1.getFullYear(), this.selectedDate1.getMonth(), this.selectedDate1.getDate()) + 86400000; // add one day's worth of milliseconds
        this.filter['fDate'] = fDate;
        this.filter['tDate'] = tDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).valueOf();
        this.filter['fDate'] = this.fromDate
    }
    toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).valueOf();
        this.filter['tDate'] = this.toDate;
    }

    async adminOrderReport() {
        this.userService.csrf().subscribe(async success => {
            this.filter["_csrf"] = success._csrf;
            await this.clientOrderSer.getAdminOrdersWithFilter(this.filter).subscribe(async adminOrders => {
                let adminDataRes = await adminOrders.data.map(adminOrder => {
                    if (adminOrder.TargetTradeTS > 0 && adminOrder.SourceTradeTS > 0) {
                        if (adminOrder.SourceSide === 'SELL') {
                            adminOrder.PNL = adminOrder.SourceTradeAmount - adminOrder.TargetTradeAmount;
                        } else if (adminOrder.TargetSide === 'SELL') {
                            adminOrder.PNL = adminOrder.TargetTradeAmount - adminOrder.SourceTradeAmount;
                        } else {
                            adminOrder.PNL = 0; // Set PNL to 0 if one side is not present
                        }
                    }
                    else {
                        adminOrder.PNL = 0; // Set PNL to 0 if one side is not present
                    }
                    adminOrder.SourceTradeTS = adminOrder.SourceTradeTS ? moment(adminOrder.SourceTradeTS).format('MM/DD/YY h:mm:ss A') : '';
                    adminOrder.CreatedAt = moment(adminOrder.CreatedAt).format('MM/DD/YY h:mm:ss A')
                    adminOrder.TargetTradeTS = adminOrder.TargetTradeTS ? moment(adminOrder.TargetTradeTS).format('MM/DD/YY h:mm:ss A') : '';
                    return adminOrder;
                })
                this.dataSource = new MatTableDataSource(adminDataRes);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            })
        });


    }
    async applyFilterDate() {
        await this.adminOrderReport();
    }
    exportArray() {
        if (this.dataSource.filteredData) {
            const adminOrderArr = this.dataSource.filteredData.map(x => ({
                Pair: x.Pair,
                SourceTradeTS: x.SourceTradeTS,
                SourceTradeDate: x.SourceTradeDate,
                SourceOrderSource: x.SourceOrderSource,
                SourceSide: x.SourceSide,
                SourceClient: x.SourceClient,
                SourceUserEmail: x.SourceUserEmail,
                SourceOrderId: x.SourceOrderId,
                SourceTradeId: x.SourceTradeId,
                SourceClientOrderId: x.SourceClientOrderId,
                SourceTradeQuantity: x.SourceTradeQuantity,
                SourceTradePrice: x.SourceTradePrice,
                SourceTradeAmount: x.SourceTradeAmount,
                SourceFee: x.SourceFee,
                SourceFeeCurrency: x.SourceFeeCurrency,
                CommentText: x.CommentText,
                CreatedAt: x.CreatedAt,
                TargetTradeTS: x.TargetTradeTS,
                TargetExchange: x.TargetExchange,
                TargetSide: x.TargetSide,
                TargetOrderId: x.TargetOrderId,
                TargetTradeId: x.TargetTradeId,
                TargetClientOrderId: x.TargetClientOrderId,
                TargetOrderSource: x.TargetOrderSource,
                TargetTradePrice: x.TargetTradePrice,
                TargetTradeQuantity: x.TargetTradeQuantity,
                TargetTradeAmount: x.TargetTradeAmount,
                TargetFee: x.TargetFee,
                TargetFeeCurrency: x.TargetFeeCurrency,
                PNL: x.PNL,
                IsActive: x.IsActive,
            }));
            TableUtil.exportArrayToExcel(adminOrderArr, "adminOrderArr");
        }

    }

    editCollateralDeposit(element) {
        this.dialog.open(EditAdminTradeMasterDialog, {
            width: 'auto',
            data: element,
        }).afterClosed().subscribe(result => {
            if (result) {
                this.adminOrderReport();
            }
        });

    }

}
export interface AdminOrderData {
    Pair: string,                           
    SourceTradeTS: string,
    SourceTradeDate: string,
    SourceOrderSource: string,
    SourceSide: string,
    SourceClient: string,
    SourceUserEmail: string,
    SourceOrderId: string,
    SourceTradeId: string,
    SourceClientOrderId: string,
    SourceTradeQuantity: string,
    SourceTradePrice: number,
    SourceTradeAmount: number,
    SourceFee: string,
    SourceFeeCurrency: string,
    CommentText: string,
    CreatedAt: string,
    TargetTradeTS: string,
    TargetExchange: string,
    TargetSide: string,
    TargetOrderId: string,
    TargetTradeId: string,
    TargetClientOrderId: string,
    TargetOrderSource: string,
    TargetOrderStatus: string,
    TargetTradePrice: string,
    TargetTradeQuantity: string,
    TargetTradeAmount: string,
    TargetFee: string,
    TargetFeeCurrency: string,
    PNL: string,
    IsActive: string,
}



// WEBPACK FOOTER //
// ./src/app/admintrademaster/admintrademaster.component.ts